const gql = String.raw;

const homepageQueries = {
  activeTaskCountForToday: gql`
    query ($selectedDate: String) {
      todayActiveTaskCount(selectedDate: $selectedDate) {
        CALL
        EMAIL
        LINKEDIN
        RESEARCH
        PRINT_MAIL
        TEXT
        THANK_VIEW
        OTHER
        TOTAL
        COMPLETED
      }
    }
  `,

  pausedForDaysTaskCount: gql`
    query ($endDate: String!) {
      pausedForDaysTaskCount(endDate: $endDate) {
        CALL
        EMAIL
        LINKEDIN
        RESEARCH
        PRINT_MAIL
        TEXT
        THANK_VIEW
        OTHER
        TOTAL
        COMPLETED
      }
    }
  `,

  fetchTrips: gql`
    query ($userId: BigInt!, $dayRange: BigInt) {
      trips(userId: $userId, dayRange: $dayRange) {
        name
        type
        upcoming_meetings(dayRange: $dayRange) {
          id
          type
          name
          start_at
          end_at
          contact_meetings {
            contact {
              id
              contact_attributes {
                name_full
              }
            }
          }
        }
      }
    }
  `,

  //todo: replace with a query which accepts date range or returns details for next 5 days
  //query to fetch counts for all journey groups for a specific date
  fetchUpcomingTaskCounts: gql`
    query (
      $taskOwnerUserId: BigInt!
      $taskStatuses: [String!]
      $includeInactive: Boolean!
      $fetchJourneysTaskCount: Boolean!
      $dayRange: Int!
      $journeyGroupType: String
      $today: String
    ) {
      getUpcomingTaskCounts(
        taskOwnerUserId: $taskOwnerUserId
        taskStatuses: $taskStatuses
        includeInactive: $includeInactive
        fetchJourneysTaskCount: $fetchJourneysTaskCount
        dayRange: $dayRange
        journeyGroupType: $journeyGroupType
        today: $today
      )
    }
  `,

  /*
  ---------------------
  Recommended Actions Queries
  ---------------------
    */

  // This fetches information about the Solicitor Record, which is what assignments are connected to.
  fetchSolicitorInformation: gql`
    query ($contactId: BigInt!) {
      solicitor(contact_id: $contactId) {
        contact_id
        assignments_pagination {
          count
        }
      }
    }
  `,

  fetchRecommendedActionsBySegment: gql`
    query ($segments: [String!], $includeViewed: Boolean) {
      recommendedActions(segments: $segments, includeViewed: $includeViewed) {
        segment
        actions {
          id
          oid
          owner_user_id
          contact_id
          viewed
          segment
          updater_user_id
          expiration_date
          deleted_at
          created_at
          updated_at
          contact {
            id
            contact_attributes {
              name_full
            }
            emails {
              email
              primary
            }
            profile_image {
              url
            }
            active_journeys {
              journey_name
              step_number
              day_number
            }
            giving {
              lifetime_amount
              last_gift_date
              last_gift_amount
              last_gift_label
            }
            enrichment {
              employment_events {
                type
                recorded_at
              }
            }
            trip_interaction {
              last_meeting_date
              last_interaction_date
            }
            dps_detail {
              dps_score
              last_interaction_date
            }
          }
        }
      }
    }
  `,

  fetchRecommendedActionsByIds: gql`
    query ($ids: [BigInt!]!) {
      recommendedActionsById(ids: $ids) {
        id
        oid
        owner_user_id
        contact_id
        viewed
        segment
        updater_user_id
        expiration_date
        deleted_at
        created_at
        updated_at
        contact {
          id
          contact_attributes {
            name_full
          }
          emails {
            email
            primary
          }
          profile_image {
            url
          }
          active_journeys {
            journey_name
            step_number
            day_number
          }
          giving {
            lifetime_amount
            last_gift_date
            last_gift_amount
            last_gift_label
          }
          enrichment {
            employment_events {
              type
              recorded_at
            }
          }
          trip_interaction {
            last_meeting_date
            last_interaction_date
          }
          dps_detail {
            dps_score
            last_interaction_date
          }
        }
      }
    }
  `,

  fetchContactIdsForRecommendedActions: gql`
    query (
      $segments: [String!]
      $userSolicitorContactId: BigInt!
      $daysSinceLastGift: Int
      $minGiftAmount: Float
      $monthsSinceLastInteraction: Int
    ) {
      contactIdsForNewRecommendedActions(
        segments: $segments
        userSolicitorContactId: $userSolicitorContactId
        daysSinceLastGift: $daysSinceLastGift
        minGiftAmount: $minGiftAmount
        monthsSinceLastInteraction: $monthsSinceLastInteraction
      ) {
        segment
        contactIds
      }
    }
  `,
};

export default homepageQueries;
